var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#8D95A1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6348 20.7273V12.766H16.3582L16.7667 9.66243H13.6348V7.68126C13.6348 6.78299 13.8881 6.17083 15.2028 6.17083L16.877 6.17015V3.39421C16.5875 3.35731 15.5936 3.27271 14.4369 3.27271C12.0216 3.27271 10.368 4.71878 10.368 7.37389V9.66243H7.63634V12.766H10.368V20.7273H13.6348Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1658_33489",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 10,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6348 20.7273V12.766H16.3582L16.7667 9.66243H13.6348V7.68126C13.6348 6.78299 13.8881 6.17083 15.2028 6.17083L16.877 6.17015V3.39421C16.5875 3.35731 15.5936 3.27271 14.4369 3.27271C12.0216 3.27271 10.368 4.71878 10.368 7.37389V9.66243H7.63634V12.766H10.368V20.7273H13.6348Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1658_33489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.5H24V23.3042H0V-0.5Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.bba49d1e085d3e67783ff7ac4124f7fa.svg";
export { ForwardRef as ReactComponent };